
    // Do not modify this file by hand!
    // Re-generate this file by running lit-localize

    import {html} from 'lit';
    import {str} from '@lit/localize';

    /* eslint-disable no-irregular-whitespace */
    /* eslint-disable @typescript-eslint/no-explicit-any */

    export const templates = {
      'h1fbdfea3ad6d664e': html`Инро лоиҳаи
                    <a href="${0}">Engine Folksonomy</a>овардааст.
                    барои иштирок кардан ё изҳори назар кардан шарм надоред`,
'h5d824b4954e56ea5': html`Scan your <span class="everyday">everyday</span> <span class="foods">foods</span>`,
'h6bdd1b427aa985a4': html`Ин восита ба шумо имкон медиҳад, ки рӯйхати компонентҳоро ислоҳ кунед. Шумо метавонед
                рӯйхати компонентҳоро илова, хориҷ ё таҳрир кунед.
                <br>
                Ин аломат <span class="highlight">␣</span> фосиларо ифода мекунад.
                <br>
                Ин аломат <span class="highlight">↩︎</span> танаффуси сатрро ифода мекунад. `,
'hb28f1f2ec1744ee9': html`Ин хосиятҳо аз ҷониби корбарон барои ҳама гуна истифодаҳо эҷод ва пешниҳод карда мешаванд. Барои илова кардани худ
                    озод ҳис кунед. Хусусиятҳо ва арзишҳое, ки шумо эҷод мекунед
                    <strong>бояд воқеӣ бошанд</strong>. Шумо метавонед ба
                    <a href="${0}">ба рӯйхати моликиятҳое, ки аз ҷониби ҷомеа аллакай истифода шудааст</a>
                    ғарқ шавед ё ҳуҷҷатҳои хосиятҳои
                    <a href="${1}">ва системаи ҷустуҷӯии онро омӯзед</a>.`,
's000a5b76bd3a01c2': `Боркунии хосиятҳо...`,
's000d98595e959c1e': `Get It On Google Play`,
's013bdc8cf0d3583d': `Барои компонентҳо ба мо кӯмак кунед`,
's01d2865e3e1d5501': `Thank you for your assistance!`,
's02ce7a2e7c1b020b': `Тасдиқи ҳосил`,
's03e9c8114521b998': `Ман компонентҳоро таҳрир мекунам`,
's05ec315d9308091a': `Нишонаи кунҷҳои штрих-код`,
's061eb5af92512c85': `Захира шуд! Метавонед бо дигаре кӯмак кунед?`,
's06847c221c4c0bc1': `Ман мехоҳам амволе эҷод кунам, то [вазъияти истифодаи шуморо тавсиф кунад]...`,
's06f6c6f99db6b552': `Асли`,
's081e2ad82db71e1d': `Арзишҳои гурӯҳбандӣ`,
's09205907b5b56cda': `No`,
's0b4235aae602a950': `ҳуҷҷатҳои махсус`,
's0bb2d48532acc455': `CSV-ро зеркашӣ кунед`,
's0d5b7fee0311db68': `Property`,
's0fb218abc2e157ed': `Беэътибор кардани тасвир`,
's100c4928cc74642a': `support the advancement of public health research.`,
's10db5498186c083b': `Киштиро бекор кунед`,
's11a18a69b30b65ed': `Ба мо кӯмак кунед, ки хатогиҳоро дар рӯйхати компонентҳо ислоҳ кунед`,
's1205d5f6fccf8e69': `Арзиши амвол`,
's15d64a0a6715285a': `Калиди нав`,
's166bd56d19670a72': `Zoom`,
's19059bf0c4f7c162': `Минтақаи интихоб`,
's1a52515ec8ddade8': `Product barcode`,
's1c5031113de500ce': `keeping our database open &amp; available to all,`,
's1dc4daf989c71284': `Ба мо дар ислоҳи маълумоти ғизоӣ кӯмак кунед`,
's1e00019dc454872d': `Лутфан номи амволро бо истифода аз атрибути номи амвол пешниҳод кунед.`,
's1e49126af0935a5b': `Рӯйхати маҳсулоте, ки ин амволро истифода мебаранд`,
's21e73088de6f26f3': `Download on the App Store`,
's255857544a9d5ec0': `Reset`,
's25e94495991e95ba': `Thanks for your help! Can you assist with another question?`,
's2ceb11be2290bb1b': `Cancel`,
's2db7b654c0a9bde0': `Ҳуҷҷати моликият`,
's300b3a6ee4e1252d': str`Мутобиқати бад ${0}%`,
's33f786bb6b4f0cf4': `Натиҷаи кишт`,
's33f85f24c0f5f008': `Save`,
's34be4af4e8fec4ae': `Аввал аз ҷомеа пурсед`,
's36d86adc823cbfa6': `Пеш аз сохтани амволи нав, онро бо ҷомеа муҳокима кунед:`,
's3781d25aa51a736c': `Ҳуҷҷатҳои муҳаррики Folksonomy`,
's383ae4449428b61e': `Барқарор кардани ҳосил`,
's39bcf88721a1e8ee': `Интихобро аз нав танзим кунед`,
's39e14e14300694c7': `Ҳуҷҷатҳо ва дастурҳо`,
's3b430cfa5c1fe7f4': str`Ҳуҷҷатҳо барои ${0}`,
's3f4e4b52f230a892': `Канваси тасвир`,
's417b90913e05bc17': `Preview`,
's41f7dca46d3f1b4a': `Value`,
's422bba9636ce2489': `Тасвири марказӣ`,
's42dd66b2441566fd': `Нишонаи марказӣ`,
's43df2e8395f6834e': str`Please give to our ${0} Fundraiser`,
's453188ea728f64da': `Add a nutrient`,
's453ab0dbb9b5c777': `Андозаи ростро тағир диҳед`,
's475b08749d0706ed': `Help us inform millions of consumers around the world about what they eat`,
's49730f3d5751a433': `Loading...`,
's4bbc7472834a9686': `Your browser does not support barcode scanning.`,
's4d42cc7e00076a3b': `Шумораи маҳсулот`,
's4df2f533c0c1e7d0': `Назорати тасвир`,
's4e94adf723979402': `Open Food Facts needs your help with this product.`,
's4f4886341969d552': `Интихобро интиқол диҳед`,
's4f751fb9b3ed766c': `Эҷоди моликияти нав`,
's547c12ae169d00bc': `Available on F-Droid`,
's5560fb119e40923d': `Номи амволро ворид кунед...`,
's55d7249883a98ca1': `дар бораи ин амвол дар викии Open Food Facts`,
's565867d84c04aea2': `Хусусиятҳои филтр...`,
's5666afe5cd0166de': `Лутфан пеш аз тасдиқ хатогиҳоро ислоҳ кунед ё матнро тағир диҳед`,
's57472465a23b41db': `Values`,
's58e1eeea7a60ae51': `Маҳсулот бор карда мешавад...`,
's59df20feee978e5b': `Error: Invalid value.`,
's5c92c0051d44b6de': `Ба мо дар ислоҳи маълумоти ғизоӣ кӯмак кунед.`,
's5dd6f12783fca34f': `Рӯйхати компонентҳоро таҳрир кунед`,
's5e8250fb85d64c23': `Close`,
's5ed03bb1f3a15949': `Picture`,
's6306a31415aea913': `I SUPPORT`,
's6498dfe4855bb3a7': `unit`,
's64ef2a6c2dd1d3d1': `Edit`,
's66413c24dcf680e2': `Skip`,
's67ae6594857a4d57': `Thanks for your contribution!`,
's6cee7cad81dfedd1': `Тасвири бурида`,
's6d7b6cdedaadfb6e': `Each donation counts! We appreciate your support in bringing further food transparency in the world.`,
's7124dde792a8faa2': `Android APK`,
's718dea04853f80ae': str`Мутобиқати хуб ${0}%`,
's71a5c9f4b68ef4d4': `Count`,
's74cb3d66f6a668e1': `Ҳуҷҷатгузорӣ`,
's787dd11bed0dc88a': `Андозаи чапро тағир диҳед`,
's7ce4fd9430e80cea': `value`,
's801a05fa8e881f37': `Маълумоти бештар дар бораи эҷоди амвол ва роҳнамо:`,
's8038273de2cf8b73': `Лутфан минтақаеро барои буридан интихоб кунед.`,
's839cc2908a5387f2': `Штрих-кодҳоро филтр кунед...`,
's86197dcf3e96af64': `Хусусиятҳои мавҷударо паймоиш ва ҷустуҷӯ кунед`,
's8a63be30a129a59c': `Андозаи поёнро тағир диҳед`,
's8a8bfd67f2dd2810': `Download the OFF app with this QR code`,
's8af61807443f32a4': `Actions`,
's8b33c244759d7bd4': `Андозаи андозаи болоро тағир диҳед`,
's8db84aa4bc949af2': `Ҳуҷҷати моликияти нав`,
's8f839a03997a16d7': `Намоиши Маҳсулот`,
's901ae1e236ac45d3': `Нест карданро бекор кунед`,
's907f7a97c6b29425': `Огоҳ бошед, ки модели маълумот метавонад тағир дода шавад. Бо хатари худ истифода баред.`,
's95d23d03f9147581': `Unzoom`,
's976dfd19ef58a1e1': `Click to scan a barcode and find out its details (health, preferences, etc.)`,
's98ff35f2a00dc60d': `Компонентҳо:`,
's9a7f60fce090ecaf': `Хосиятҳоро бор карда натавонист. Лутфан баъдтар бори дигар кӯшиш кунед.`,
's9b87abd68fb9df45': `Дарёфт нашуд? Эҷоди калиди нав {value}`,
's9c0f52425fd2f07e': `Муносиб набошад`,
's9fc41f789c63b40d': `Products`,
'sa1fa766e0d5634d7': `Хол дастрас нест`,
'sa548778b24054030': `Ҳамаи хосиятҳои саҳмгузори лоиҳаи Folksonomy Engineро омӯзед. Ин хосиятҳо метамаълумоти иловагӣ ва фаҳмишҳоро дар бораи маҳсулот дар пойгоҳи додаҳои Open Food Facts таъмин мекунанд.`,
'sa63907958bd0ec4b': `Тағйир додани андозаи чапи боло`,
'sa95b4224f685a36a': `Модалро пӯшед`,
'sab56a1d439576fd6': `Нишонаи пешниҳод`,
'sac47ea2901d04c15': `Тағйир додани андоза дар поёни чап`,
'sb125227d436c2925': `Ҷустуҷӯи консепсияи амволи худ дар базаи моликияти мавҷуда:`,
'sb125568d43642e6f': `Ба саволҳо дар бораи маҳсулот ҷавоб диҳед.`,
'sb1c538e038f9b214': str`Мутобиқати хеле хуб ${0}%`,
'sb28639570ff3b852': `рӯйхати ҳамаи моликият`,
'sb3bdd638a58d30f4': `engage a community of committed citizens,`,
'sb3cbcc1bd0fff140': `Вақте ки шумо тасдиқ кардед, ки моликияти шумо вуҷуд надорад ва ҷомеа розӣ аст, ки он муфид аст, шумо бояд аввал онро дар вики ҳуҷҷатгузорӣ кунед.`,
'sb3d4f79d9d8b71e5': `Submit`,
'sb560fa37a7bfb6c2': `Ягон маҳсулот барои ин амвол ёфт нашуд.`,
'sb7f72e4c8a2d3357': `Арзишҳои филтр...`,
'sb8178320160f84ea': `Нишон додани ҳосил`,
'sbad7d2734149470b': `Validate`,
'sbb623d6b18d966a0': `Nutrition facts are displayed on the packaging:`,
'sbd6be5cde472f37c': `Ҳама фаҳмишҳо ҷавоб дода шуданд! Сипос аз ёрмандии шумо!`,
'sbd9a0b2293b3cd3c': `Serving size`,
'sbe472dc3c2685985': `Арзиши мувофиқ`,
'sc0520e1732a5c568': `Expand image`,
'sc0cc559e7ede852a': `Андозаи болоро тағир диҳед`,
'sc1c08d0cbcc3bd24': `Мутобиқ нест`,
'sc52696641af72b53': `Install the app!`,
'sc5575e3107f87874': `Rotate image to the left`,
'sc57b630a7a70c61f': `Ислоҳи тавсияшуда`,
'sc681b137e8f604f7': `Confirm deletion`,
'sc6daf8a31883f8b9': `Тасвирро интиқол диҳед`,
'sc895972c88d38ca5': `Амволи халқӣ`,
'sca0c3305aff570b8': str`per specified serving "${0}"`,
'scace072bef961918': `Қаторҳо`,
'scb3b0671d7b7f640': `Арзиши нав`,
'scb489a1a173ac3f0': `Yes`,
'scbab4bd737ba7934': str`group photo donation ${0}`,
'scd21019c3cd618f3': `Ба муҳокимаи Slack ҳамроҳ шавед`,
'scdb6cad0b92721bf': `Ягон хосият ёфт нашуд.`,
'scf23a05631f93732': `Нест карданро тасдиқ кунед`,
'scfed2f270ef6a3aa': `Минтақаро интихоб кунед`,
'sd1022bc1ef9204f7': `Тасвири калоншаванда`,
'sd1077c055cf9ba6b': `Ба мо кӯмак кунед, ки рӯйхати компонентҳои маҳсулотро тасдиқ кунем.`,
'sd698d21ddecba56b': `Эй! Шумо метавонед бо ҷавоб додан ба қисмҳои зерин ба мо дар беҳтар кардани маълумоти маҳсулот кӯмак кунед:`,
'sd82bc2decefa621b': `remain independent of the food industry,`,
'sdb97e5976482606e': `Санҷед, ки оё моликият аллакай вуҷуд дорад`,
'sdbf806fefc584115': `Шумо бояд а`,
'sdc673e73b5c13aea': `Delete`,
'sdc792b75f1edcaba': `Ба мо дар ислоҳи имлои компонентҳо кӯмак кунед.`,
'sdca5deead576ceee': `Андозаи андозаи поёни рост`,
'sdcc2555c5dde524f': `Шумо мутмаин ҳастед, ки мехоҳед ин ашёро нест кунед? Ин амалро бекор кардан мумкин нест.`,
'se206feec7ec57b28': `per 100g`,
'se419a9ab36987490': `Беэътибор донистан`,
'se5127cf0f92e7e48': `Маслиҳат: шумо инчунин метавонед пайдо кунед`,
'se773f50d2a16d481': `Rotate image to the right`,
'sebb2c6c830a44574': `technical infrastructure (website/mobile app) &amp; a small permanent team`,
'sec6377f3c4e9b28c': `Ман ҳосили беҳтарро пешниҳод мекунам`,
'seea3800e27baa686': `Маҳсулоти инфиродӣ`,
'sefaba4adc4ec9219': `Хусусиятҳои фолксономӣ`,
'seffa8ca49175b5f0': `Хусусиятҳои фардӣ`,
'sf44a6b3b232c28ea': str`Қимати ҷориро бо ${0}иваз кунед`,
'sf4cd86a2f5ef2588': `Штрих-коди маҳсулот`,
'sf57a61152168cc81': `Ба мо дар ислоҳи муайянкунии компонент кӯмак кунед`,
'sf88b90b8ba23871c': `Бозии номаълум`,
'sf9aee319a006c9b4': `Add`,
'sfacbbe968fa7d773': `Номи амвол:`,
'sfc40ea3d5d5aa6f8': `Your donations fund the day-to-day operations of our non-profit association:`,
'sfe87465d50530725': `Арзиши мувофиқ`,
's5f343a43e7ea9f91': `Error`,
'sd947a599045e9e0e': `Failed to check property conflicts. Please try again.`,
's92a0d19a28995530': `Success`,
's371091f240c17a7e': `Property renamed successfully!`,
's4603f58131a777bf': `Failed to rename property. Please try again.`,
's21694d2ab9c0bec5': `Property deleted successfully!`,
'scf78b75273a6b5fe': `Failed to delete property. Please try again.`,
's71ffcb25fc1c5356': `Rename this property`,
's60320a18282b2b33': `Rename`,
's6e2a82009cc3dfc7': `Delete this property`,
's8bccacf0fc176064': `Rename Property`,
's0df37909a355e56f': str`Rename property '${0}' to:`,
'sb550440eeb3f39c5': `New property name:`,
'sbb53591e587764b7': `Enter new property name...`,
's8acd49e96b4ee7d4': `Check Conflicts`,
'sd1cfdf0ef29cb6a5': `Property Rename Conflicts`,
'sf417737adaa5a8c2': str`Renaming '${0}' to '${1}' will affect:`,
's14571d0ac58a8b43': `Products with both properties:`,
'sb0d459e32656033f': `Products with old property only:`,
'sfa3027dde47305fe': `Products with new property only:`,
's9e5b8feb0892646e': `Do you want to proceed with the rename?`,
's97171907a2d1620b': `Proceed with Rename`,
's712d70fdcc3dd42b': `Delete Property`,
'sc11b78f2f3173f75': str`Are you sure you want to delete the property '${0}'?`,
's3b3fe4e829af3e8e': `This action cannot be undone.`,
's091d3d07b5b3076f': `OK`,
's72c9c4e6ab4ca7ae': `Value replaced successfully!`,
'sdd0eacd725bb2b1d': `Failed to replace value. Please try again.`,
'sfe87a7a8bed11acf': `Value deleted successfully!`,
'sccd2745bdd1087f6': `Failed to delete value. Please try again.`,
's88ece9a678e2f106': `Replace Value`,
's3355d65e22e222c9': str`Replace all instances of '${0}' with a new value:`,
's0d426d718d97d14e': `New value:`,
'se80a1ed3dcab7408': `Enter new value...`,
's2a8434b16dc214a3': `Replace`,
's8263352c7a634e7f': `Delete Value`,
'sebe99e3299746177': str`Are you sure you want to delete all instances of the value '${0}'?`,
's4b0b53abbd6af54a': `Replace this value across all products`,
'sb02836b5e3176cfe': `Delete this value from all products`,
    };
  